<template>
    <article
            class="model"
            :class="{placeholder: placeholder, horizontal: horizontal}"
    >
        <!--
        @click="horizontal = true"
            @mouseenter="horizontal = true"
            @mouseleave="horizontal = false"
        -->
        <template v-if="!placeholder">
            <router-link :to="{name: 'model.profile', params: {id: model.id}}">
                <div
                        class="img"
                        :style="imgStyle"
                >
                    <template v-if="horizontal">
                        <router-link :to="{name: 'model.profile', params: {id: model.id}}">
                            <div class="filler">

                            </div>
                        </router-link>
                    </template>
                </div>
                <div class="text">
                    <h4 class="name">
                        {{model.name}}
                    </h4>
                </div>
            </router-link>
        </template>
        <template v-else>
            <div class="img"></div>
            <div class="text">
                <h4 class="name"></h4>
                <h6 class="description"></h6>
            </div>
        </template>
    </article>
</template>
<script>
    export default {
        props: {
            model: {
                type: Object,
                required: false,
                validate(value){
                    return value !== undefined || this.placeholder;
                }
            },
            placeholder: {
                type: Boolean,
                required: false,
                default: false
            },
        },
        data(){
            return {
                horizontal: false,
            };
        },
        computed: {
            imgStyle(){
                let image = (this.horizontal) ? this.model.public_image_path['small'] : this.model.public_vertical_image_path['small'];

                return {
                    backgroundImage: `url('${image}')`
                };
            }
        }
    }
</script>
<style scoped lang="scss">
    @import '../styles/variables';

    .model{
        padding-left: 5px;
        padding-right: 5px;
        margin-bottom: 10px;
        margin-top: 10px;
        transition: width .5s ease;
        max-width: calc(100vw - 20px);

        .img{
            background-color: var(--pallete_secondary_color);
            width: 100%;
            background-size: cover;
            background-position: center;
            height: 300px;
            margin-bottom: .5em;
            position: relative;

            .filler{
                position: absolute;
                background-color: transparent;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
            }
        }

        .text{
            text-align: left;

            .description{
                margin: 0;
                color: var(--pallete_clear_text_color);
            }

            .name{
                margin: 0;
            }
        }

        &.placeholder{
            .img{
                background-color: rgba(128,128,128,.25);
            }

            .text{
                .name{
                    background-color: rgba(128,128,128,.25);
                }

                .description{
                    background-color: rgba(128,128,128,.25);
                }
            }
        }
    }
</style>